export * from "./lib/mzt-intranet-conf";
